import { ArrowsCounterClockwiseIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Update = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ArrowsCounterClockwiseIcon size={Sizes[size]} {...rest} color={fill} />;
};

Update.displayName = 'Update';
